import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCalendar1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCalendar1"><Path d="M9 2V4H15V2H17V4H21V9H3V4H7V2H9Z" fill="currentColor"/><Path d="M3 11V21H21V11H3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCalendar1;
